import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import TopAdd from "components/TopAdd";
import Topnav from "components/Topnav";
import RightAdd from "components/RightAdd";

import { useParams } from "react-router";

import { Link } from "react-router-dom";
import { getGameById, putGame } from "services/game_service";
import { getTeamMembersByIDs } from "services/teams_service";

function App() {
  const { gameId } = useParams();
  const navigate = useNavigate();

  const [members, setMembers] = useState([]);
  const [playersIdList, setPlayerListId] = useState([]);
  const [homeGoals, setHomeGoals] = useState(0);
  const [awayGoals, setAwayGoals] = useState(0);
  const [gameStatistics, setGameStatistics] = useState([]);

  useEffect(() => {
    async function getTeamsFunc() {
      try {
        const gameObj = await getGameById(gameId);

        const playersList = gameObj.attributes.players.data.map((el) => {
          return el.id;
        });

        const memberList = await getTeamMembersByIDs(playersList);

        setPlayerListId(gameObj.attributes.players.data.map((el) => el.id));
        setMembers(memberList);

        initializeMembers(memberList, gameObj?.attributes?.players_status);
        setHomeGoals(gameObj?.attributes?.home_team_goals);
        setAwayGoals(gameObj?.attributes?.away_team_goals);
      } catch (exception) {
        console.log("exception: ", exception);
      }
    }

    getTeamsFunc();
  }, []);

  const initializeMembers = (playersList, player_status) => {
    playersList = playersList.map((el) => {
      const stats = player_status?.find((stats) => stats.id === el.id);

      return {
        attributes: el.attributes,
        id: el.id,
        playedMinutes: stats?.playedMinutes ? stats.playedMinutes : 0,
        goals: stats?.goals ? stats.goals : 0,
        assists: stats?.assists ? stats.assists : 0,
        yellowCards: stats?.yellowCards ? stats.yellowCards : 0,
        redCards: stats?.redCards ? stats.redCards : 0,
      };
    });

    setMembers(playersList);
    setGameStatistics(playersList);
  };

  const setStatistics = (value, playerId, statistic) => {
    const stats = gameStatistics.map((el) => {
      if (el.id === playerId) {
        el[statistic] = value;
      }

      return el;
    });

    setGameStatistics(stats);
  };

  const saveConvocatoria = async () => {
    await putGame(gameId, {
      players_status: gameStatistics,
      away_team_goals: awayGoals ? awayGoals : 0,
      home_team_goals: homeGoals ? homeGoals : 0,
    });
    navigate(`/jogos/${gameId}`);
  };

  return (
    <div className="geral">
      <div className="App">
        <Topnav></Topnav>
        <div className="conteudo">
        <TopAdd></TopAdd>
        <div style={{"display": "flex"}}>
          <section className="section dashboard">
            <nav className="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <Link to={"/equipas"}>Plantel</Link>/ Detalhe
              </ul>
            </nav>
            <div className="geral">
              <div className="hero is-footsolution">
                <div className="columns">
                  <div className="column">
                    <h1 className="title is-3">Adicionar Resultados</h1>
                  </div>
                </div>
              </div>
            </div>
            <h2>Resultado</h2>
            <div className="flex">
              <input
                className="input"
                style={{"width": "65px"}}
                min="0"
                max="50"
                type="number"
                value={homeGoals || 0}
                onChange={(e) => {
                  setHomeGoals(e.target.value);
                }}
              />
              <input
                className="input"
                style={{"width": "65px"}}
                min="0"
                max="50"
                type="number"
                value={awayGoals || 0}
                onChange={(e) => {
                  setAwayGoals(e.target.value);
                }}
              />
            </div>
            <br></br>
            <br></br>

            <h2>Jogadores</h2>
            <table className="table fullwidth">
              <thead>
                <tr>
                  <th>
                    <abbr title="Position">Nome</abbr>
                  </th>
                  <th>
                    <abbr title="Played">Posição</abbr>
                  </th>
                  <th>
                    <abbr title="Won">Minutos Jogados</abbr>
                  </th>
                  <th>
                    <abbr title="Won">Assistencias</abbr>
                  </th>
                  <th>
                    <abbr title="Won">Golos</abbr>
                  </th>
                  <th>
                    <abbr title="Won">Amarelos</abbr>
                  </th>
                  <th>
                    <abbr title="Won">Vermelhos</abbr>
                  </th>
                </tr>
              </thead>
              <tbody>
                {members.map((el, idx) => (
                  <tr key={idx}>
                    <td>{el.attributes.name}</td>
                    <td>{el.attributes?.position?.join(", ")}</td>
                    <td>
                      <input
                        style={{ maxWidth: "60px" }}
                        className="input"
                        min="0"
                        max="90"
                        type="number"
                        placeholder="90"
                        value={el.playedMinutes || ""}
                        onChange={(e) => {
                          setStatistics(e.target.value, el.id, "playedMinutes");
                        }}
                      />
                    </td>
                    <td>
                      <input
                        style={{ maxWidth: "60px" }}
                        className="input"
                        min="0"
                        max="20"
                        type="number"
                        value={el.assists || ""}
                        onChange={(e) => {
                          setStatistics(e.target.value, el.id, "assists");
                        }}
                      />
                    </td>
                    <td>
                      <input
                        style={{ maxWidth: "60px" }}
                        className="input"
                        min="0"
                        max="50"
                        type="number"
                        value={el.goals || ""}
                        onChange={(e) => {
                          setStatistics(e.target.value, el.id, "goals");
                        }}
                      />
                    </td>
                    <td>
                      <input
                        style={{ maxWidth: "60px" }}
                        className="input"
                        min="0"
                        max="2"
                        type="number"
                        value={el.yellowCards || ""}
                        onChange={(e) => {
                          setStatistics(e.target.value, el.id, "yellowCards");
                        }}
                      />
                    </td>
                    <td>
                      <input
                        style={{ maxWidth: "60px" }}
                        className="input"
                        min="0"
                        max="1"
                        type="number"
                        value={el.redCards || ""}
                        onChange={(e) => {
                          setStatistics(e.target.value, el.id, "redCards");
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <button onClick={() => saveConvocatoria()} className="button">
              Gravar
            </button>
            <br />
            <br />* Valores em branco serão considerados 0.
            {!playersIdList ||
              (playersIdList.length === 0 && (
                <>
                  <br />
                  Não existem jogadores convocados para este jogo. Confira que
                  enviou a convocatória.
                </>
              ))}
          </section>
          <RightAdd></RightAdd>
         </div>
        </div>
      </div>
    </div>
  );
}

export default App;
